import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ServiceContentsScreenSelectorButton from '@/components/Ui/ServiceContentsScreenSelectorButton'
import VideochatSelectorButton from '@/components/Ui/VideoChatSelectorButton'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceContentsRegistKeyAssignModal',
  components: {
    ServiceContentsScreenSelectorButton,
    VideochatSelectorButton,
    Loading
  },
  props: {
    index: Number
  },
  data () {
    return {
      // form
      inpKeyCode: '',
      inpActionType: '',
      // inpParameter: null,
      inpWebUrl: null,
      inpSpApp: null,
      inpDataUri: null,
      inpExtraData: [
        { k: null, value: null, dataType: null },
        { k: null, value: null, dataType: null },
        { k: null, value: null, dataType: null },
        { k: null, value: null, dataType: null },
        { k: null, value: null, dataType: null },
        { k: null, value: null, dataType: null },
        { k: null, value: null, dataType: null },
        { k: null, value: null, dataType: null },
        { k: null, value: null, dataType: null },
        { k: null, value: null, dataType: null },
      ],
      inpMineType: null,
      inpAction: null,
      inpScreenCode: '',
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.serviceContentsRegistKeyAssignModal.active,
      serviceId: state => state.serviceContentsRegistKeyAssignModal.serviceId,
      serviceContentsId: state => state.serviceContentsRegistKeyAssignModal.serviceContentsId,
      model: state => state.serviceContentsRegistKeyAssignModal.model,
      values: state => state.serviceContentsRegistKeyAssignModal.values,
    }),
    ...mapGetters({
      isRegister: 'serviceContentsRegistKeyAssignModal/isRegister',
      isModify: 'serviceContentsRegistKeyAssignModal/isModify'
    }),

    acceptLabel () {
      return this.isRegister ? '追加' : '編集'
    },

    // list
    keyCodeList () {
      // console.log(this.model)
      return Constants.ServiceContents.KeyCode.filter(code => {
        return this.isRegister
          ? this.model.findIndex(item => item.keyCode === code.value) === -1
          : this.model.findIndex(item => item.keyCode === code.value) === -1 ||
            code.value === this.values.keyCode
      })
    },
    actionTypeList () {
      return Constants.ServiceContents.KeyActionType
    },

    // show
    showTextParameter () {
      return this.inpActionType === 1 ||
        this.inpActionType === 2
    },
    showScreenParameter () {
      return this.inpActionType === 3
    },

    // validate
    inpKeyCodeIsValid () {
      return Validator.validSelect(this.inpKeyCode)
    },
    inpActionTypeIsValid () {
      return Validator.validSelect(this.inpActionType)
    },
    formIsValid () {
      return this.inpKeyCodeIsValid &&
        this.inpActionTypeIsValid
    },
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    inpActionType (to, from) {
      if (from !== '') {
        // this.inpParameter = null
        this.inpWebUrl = null
        this.inpSpApp = null
        this.inpScreenCode = ''
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showToast: 'toast/show',
      hide: 'serviceContentsRegistKeyAssignModal/hide',
      setUpdated: 'serviceContentsRegistKeyAssignModal/setUpdated'
    }),
    ...mapMutations({
      setValues: 'serviceContentsRegistKeyAssignModal/setValues'
    }),

    init () {
      // console.log('@@@@', this.serviceContentsId)
      console.log('@@@@', this.values)
      // データ更新フラグの初期化
      this.setUpdated(false)

      if (this.isModify) {
        this.inpKeyCode = this.values.keyCode
        this.inpActionType = this.values.actionType
        // this.inpParameter = this.values.parameter

        if (this.values.parameter) {
          this.inpWebUrl = this.values.parameter.webUrl || null
          this.inpSpApp = this.values.parameter.launchSpApp || null
          this.inpScreenCode = this.values.parameter.screenCode || null
          this.inpDataUri = this.values.parameter.dataUri || null
          this.inpMineType = this.values.parameter.mimeType || null
          this.inpAction = this.values.parameter.action || null

          const extraData = this.values.parameter.extraData
            .map(item => {
              return {
                k: item.key,
                value: item.value,
                dataType: item.dataType,
              }
            })
            .forEach((item, index) => {
              this.$set(this.inpExtraData, index, item)
            })
        }
        // this.inpWebUrl = this.values.parameter
        //   ? this.values.parameter.webUrl || null
        //   : null
        // this.inpSpApp = this.values.parameter
        //   ? this.values.parameter.launchSpApp || null
        //   : null
        // this.inpScreenCode = this.values.parameter
        //   ? this.values.parameter.screenCode || ''
        //   : ''
      }
    },

    /**
     * 画面の変更
     */
    changeScreenFromSelector (props) {
      console.log('changeScreenFromSelector', props)
      // this.$set(this, 'inpParameter', props.data.screenCode)
      this.$set(this, 'inpScreenCode', props.data.screenCode)
    },
    changeExtraDataSelector (props) {
      this.$set(this, 'inpExtraData', props.data)
    },
    /**
     * 画面の削除
     */
    deleteScreenFromSelector (props) {
      console.log('deleteScreenFromSelector', props)
      // this.$set(this, 'inpParameter', null)
      this.$set(this, 'inpScreenCode', '')
    },

    selectItem (props) {
      let data = {
        keyCode: this.inpKeyCode,
        actionType: this.inpActionType,
      }
      if (data.actionType === 1) {
        data.parameter = {}
        if (Validator.validText(this.inpSpApp)) {
          data.parameter.launchSpApp = this.inpSpApp
        }
        if (Validator.validText(this.inpDataUri)) {
          data.parameter.dataUri = this.inpDataUri
        }
        if (Validator.validText(this.inpMineType)) {
          data.parameter.mimeType = this.inpMineType
        }
        if (Validator.validText(this.inpAction)) {
          data.parameter.action = this.inpAction
        }
        const extraData = this.inpExtraData
          .filter(item => Validator.validText(item.k) &&
            Validator.validText(item.value) &&
            Validator.validText(item.dataType))
          .map(item => {
            return {
              key: item.k,
              value: item.value,
              dataType: item.dataType,
            }
          })
        if (extraData.length) {
          data.parameter.extraData = extraData
        }
      }
      if (data.actionType === 2) {
        data.parameter = {
          webUrl: this.inpWebUrl,
        }
      }
      if (data.actionType === 3) {
        data.parameter = {
          screenCode: this.inpScreenCode,
        }
      }
      // 情報をstoreに保持
      this.setValues(data)

      // データ更新フラグを有効
      // 呼び出し元のページで一覧を更新するため
      this.setUpdated(true)

      this.closeModal()
    },

    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}